import Alpine from 'alpinejs';
import Splide from '../../Helper/NeosSplide';
import {Video} from '@splidejs/splide-extension-video';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

Alpine.data('slider', () => ({
    init() {
        const splide = new Splide(this.$root);

        splide.on('mounted', function () {
            splide.refresh();
        });

        let isAutoScroll = !!JSON.parse(this.$root.dataset.splide).autoScroll;
        let plugins = {Video};
        if (isAutoScroll) {
            plugins = {Video, AutoScroll};
        }

        // fix active class assigment
        splide.on('move', function () {
            let current = splide.Components.Elements.slides[splide.Components.Controller.getIndex() - 1];
            let next = splide.Components.Elements.slides[splide.Components.Controller.getNext() - 1];
            next ? next.classList.add('is-active') : null;
            current ? current.classList.remove('is-active') : null;
        });

        // custom arrows
        const arrows = document.querySelector(`[data-slider-id="${splide.root.id}"]`);
        if (arrows) {
            let prev = arrows.querySelector('.splide__arrow--prev');
            let next = arrows.querySelector('.splide__arrow--next');

            prev.addEventListener('click', () => {
                splide.go('-1');
            });

            next.addEventListener('click', () => {
                splide.go('+1');
            });
        }

        // Support videos and disable the play button in the backend
        splide.mount(plugins);
        const inNeosBackend = window.name === 'neos-content-main';
        splide.Components.Video.disable(inNeosBackend);
        const maxIndex = splide.length - 1;
        splide.on('autoplay:playing', (rate) => {
            // Go to the first slide after the last slide
            if (rate === 1 && maxIndex === splide.index) {
                splide.go(0);
            }
        });
    },
}));
